export default __webpack_public_path__ + "static/0142-aeed97fe96cf8c53b05f2a0d861475e3.png";